import {ThumbsUp, ThumbsDown} from "lucide-react";
import * as m from "@/paraglide/messages";
import {cn} from "@/lib/utils";
import {Button} from "@/components/ui/button";
import type {SentimentType} from "@/hooks/use-sentiment-influencers";

interface SentimentToggleProps {
  selected: SentimentType;
  counts: {positive: number; negative: number};
  onSelect: (sentiment: SentimentType) => void;
  className?: string;
}

export function SentimentToggle({selected, counts, onSelect, className}: SentimentToggleProps) {
  return (
    <div className={cn("flex gap-2", className)}>
      <Button
        variant={selected === "positive" ? "default" : "outline"}
        size="sm"
        onClick={() => onSelect("positive")}
        className={cn(
          "gap-2 transition-all duration-200",
          selected === "positive"
            ? "bg-green-600 text-white shadow-md shadow-green-500/20 hover:bg-green-700"
            : "hover:border-green-500/50 hover:text-green-500"
        )}
      >
        <ThumbsUp className="h-4 w-4" />
        <span>{m.influencers_positive()}</span>
        <span
          className={cn(
            "ml-1 rounded-full px-2 py-0.5 text-[10px] font-semibold tabular-nums",
            selected === "positive" ? "bg-white/20" : "bg-muted text-muted-foreground"
          )}
        >
          {counts.positive}
        </span>
      </Button>

      <Button
        variant={selected === "negative" ? "default" : "outline"}
        size="sm"
        onClick={() => onSelect("negative")}
        className={cn(
          "gap-2 transition-all duration-200",
          selected === "negative"
            ? "bg-red-600 text-white shadow-md shadow-red-500/20 hover:bg-red-700"
            : "hover:border-red-500/50 hover:text-red-500"
        )}
      >
        <ThumbsDown className="h-4 w-4" />
        <span>{m.influencers_negative()}</span>
        <span
          className={cn(
            "ml-1 rounded-full px-2 py-0.5 text-[10px] font-semibold tabular-nums",
            selected === "negative" ? "bg-white/20" : "bg-muted text-muted-foreground"
          )}
        >
          {counts.negative}
        </span>
      </Button>
    </div>
  );
}
